import React from 'react';
import team from './user.png';
import css from './TeamCard.module.css';

function TeamCard({teamMember}) {
  const imgSrc = teamMember.image !== null ? teamMember.image.Location : team;
  return (
    <div className={css.cardWrapper}>
      <div className={css.imageWrapper}>
        <img src={imgSrc} alt="" />
      </div>
      <div className={css.cardContent}>
        <h5>{teamMember.name}</h5>
        <h6>{teamMember.position}</h6>
      </div>
    </div>
  )
}

export default TeamCard
